const sxStyles = ({ breakpoints, palette, spacing }) => ({
    title: {
        fontSize: "3rem",
        fontWeight: 500,
        lineHeight: "1",
        marginTop: spacing(1),
    },
    subtitle: {
        fontWeight: 400,
        fontSize: "1.5rem",
    },
    paper: {
        width: spacing(88.5),
        maxWidth: "100%",
        padding: spacing(6),
        boxShadow: "0px 20px 60px 2px rgba(0, 60, 145, 0.10)",
        textAlign: "center",
        borderRadius: "8px",
        [breakpoints.down("md")]: {
            width: spacing(67.5),
        },
    },
    icon: {
        fontSize: "3.8rem",
        lineHeight: "1px", // disables extra spacing below
        color: palette.primary.main,
    },
});
export default sxStyles;
//# sourceMappingURL=ErrorPage.style.js.map